import Inactive from './Inactive'

export * from './Inactive'

export default Inactive
